// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"c788ca5b","364":"298e1699","511":"20eef819","573":"ad067e89","621":"ce6913f4","691":"f35516d5","884":"d1350a7f"}[chunkId] + ".css";
};